import React from 'react';
import * as styles from './videoTitleTextSection.module.scss';
import { usePageContext } from '../context/pageContext';
import ReactPlayer from 'react-player/youtube';
import { SanityVideoTitleTextSection } from 'graphql-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import useWindowSize from '../hooks/useWindowSize';
import { Blocks } from '../ui/blocks/Blocks';
import { findTranslation } from '../../utils/findTranslation';

interface Props {
  section: SanityVideoTitleTextSection;
}

export const VideoTitleTextSection: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();
  const { width, height } = useWindowSize();

  const content = (
    <>
      {section?.activeMedia && <div className={styles.overlayTop} />}
      <div className={styles.content}>
        <div className={styles.text}>
          <Blocks blocks={findTranslation(section?._rawVideoTextSection, lang, defaultLang)} />
        </div>
      </div>
      {section?.activeMedia && <div className={styles.overlayBottom} />}
    </>
  );

  return (
    <div
      className={styles.wrapper}
      data-colorbg={section.backgroundColor}
    >
      {section?.activeMedia ? (
        <div className={styles.container}>
          <div className={styles.image}>
            <GatsbyImage
              alt={section?.imgBgVideo?.alt ?? ''}
              image={section?.imgBgVideo?.img?.asset?.gatsbyImageData}
            />
          </div>
          <div className={styles.imageDesktop}>
            <GatsbyImage
              alt={section?.imgBgVideoDesktop?.alt ?? ''}
              image={section?.imgBgVideoDesktop?.img?.asset?.gatsbyImageData}
            />
          </div>
          {content}
        </div>
      ) : (
        <>
          <div className={styles.cropped}>
            <div className={styles.player}>
              <ReactPlayer
                url={section?.videoUrlDesktop ?? ''}
                width={width >= 1024 ? '100%' : `${height / 0.5625}px`}
                height="100%"
                className={styles.reactPlayer}
                muted
                playing={true}
                loop
                playsinline
                config={{
                  playerVars: {
                    showinfo: 0,
                    controls: 0,
                    autoplay: 1,
                    loop: 0,
                    modestbranding: 1,
                    disablekb: 1,
                  },
                }}
                type="video/mp4"
              />
            </div>
            {content}
          </div>
        </>
      )}
    </div>
  );
};
